import React, { useState, useMemo, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import {
  MenuMobileIcon,
  SearchMobileIcon,
  PortfolioIconMobile,
  SupportMobileIcon,
  PowerOff,
  ExpandIcon,
  ClearIcon,
} from '../components/Icons'
import backIcon from '../assets/images/back.svg'
import SearchMobile from '../components/SearchMobile'
import companySearchList from '../data/mock/ticker-data/companies'
import { Context as PortfolioContext } from '../contexts/portfolio'

const useStyles = makeStyles(theme => ({
  mobileHead: {
    height: 60,
    background: '#1B3963',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '0px 20px',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 100,
  },
  menuIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchMobileIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portfolioIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    '& img': {
      maxWidth: 22,
    },
  },
  menuMobileContentContainer: {
    width: '100%',
    height: '100vh',
    background: 'rgba(0,0,0,0.2)',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 9,
    transition: 'all 0.3s',
  },
  menuMobileContent: {
    width: 310,
    height: '100vh',
    background: '#1B3963',
    position: 'relative',
    zIndex: 10,
    boxSizing: 'border-box',
  },
  menuItemMobileLogo: {
    paddingLeft: 20,
    paddingRight: 20,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  menuItemMobile: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20,
    boxSizing: 'border-box',
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  menuItemMobileActive: {
    borderRight: '4px solid #3393F3',
  },
  menuItemText: {
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 600,
    color: 'white',
    marginLeft: 10,
  },
  topMobileMenuPart: {
    height: 50,
  },
  bottomMobileMenuPart: {
    height: 'calc(100% - 50px)',
    paddingTop: 28,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
  },
  bottomMobileLogout: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 18,
    paddingLeft: 20,
    paddingRight: 20,
    width: '100%',
  },
  mobileLogoutCombo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  mobileLogoutSnap: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transformOrigin: 'center',
    transform: 'rotate(180deg)',
  },
  logoutMobileIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoutMobileText: {
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 600,
    color: 'white',
    marginLeft: 10,
  },
  subMenuItemCOmbo: {
    width: '100%',
  },
  searchMobileContent: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: 10,
    background: '#f5f8ff',
    left: 0,
    top: 0,
    boxSizing: 'border-box',
    padding: '24px 20px',
  },
  searchMobileBox: {
    width: 'calc(100% - 100px)',
    position: 'relative',
  },
  searchMobileCancel: {
    width: '50px',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
  },
}))

const MobileHead = () => {
  const classes = useStyles()
  const [toggleMenuMobile, setToggleMenuMobile] = useState(false)
  const [toggleSearch, setToggleSearch] = useState(false)
  const [recent, setRecent] = useState<any>([])
  // const companies = useMemo(() => [...recent, ...companySearchList], [
  //   recent,
  //   companySearchList,
  // ])
  const { state } = useContext(PortfolioContext)

  const history = useHistory()
  const isPortfolioPage =
    window.location.pathname === '/' ||
    window.location.pathname.indexOf('portfolio') !== -1
  const onToggleMenu = () => setToggleMenuMobile(true)
  const onHandleCloseMenu = (event: any) => {
    if (event.target !== event.currentTarget) return
    setToggleMenuMobile(false)
  }
  const onLogOut = () => {
    localStorage.clear()
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`)
    })
    window.location.href = '/login'
  }
  const onExpandAction = () => {
    setToggleMenuMobile(false)
  }
  const onClickPortfolioItem = () => {
    setToggleMenuMobile(false)
    history.push('/')
  }
  const onActiveSearch = () => {
    setToggleSearch(true)
  }
  return (
    <div className={classes.mobileHead}>
      <div onClick={onToggleMenu} className={classes.menuIcon}>
        <MenuMobileIcon />
      </div>
      <div onClick={onActiveSearch} className={classes.searchMobileIcon}>
        <SearchMobileIcon />
      </div>
      <SearchMobile
        searchList={state.tickersInUniverse}
        setToggleSearch={setToggleSearch}
        style={{
          transform: `translateX(${toggleSearch ? '0vw' : '-100%'})`,
        }}
      />
      <div
        onClick={onHandleCloseMenu}
        className={classes.menuMobileContentContainer}
        style={{
          transform: `translate(${toggleMenuMobile ? '0px' : '-100%'})`,
        }}
      >
        <div className={classes.menuMobileContent}>
          <div className={classes.bottomMobileMenuPart}>
            <div className={classes.subMenuItemCOmbo}>
              <div onClick={onLogOut} className={classes.menuItemMobile}>
                <div className={classes.logoutMobileIcon}>
                  <PowerOff />
                </div>
                <div className={classes.logoutMobileText}>Log Out</div>
              </div>

              {/* <div className={`${classes.menuItemMobile} ${classes.menuItemMobileActive}`}>
                <div className={classes.portfolioIcon}><SupportMobileIcon /></div>
                <div className={classes.menuItemText}>Support</div>
              </div> */}
            </div>

            <div className={classes.bottomMobileLogout}>
              <div
                onClick={onExpandAction}
                className={classes.mobileLogoutSnap}
              >
                <ExpandIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileHead
